import type { ICard } from "../../cardsSlice";

export const major11Card: ICard = {
    id: "major_11",
    arcana: "major",
    number: 11,
    suit: "major",
    court: "major",
    name: "Справедливость",
    nameEn: "Justice",
    keywords: ["Равновесие", "Ответственность", "Истина"],
    symbolism: ["Женщина с мечом и весами", "Красное одеяние, корона", "Колонны на заднем плане"],
    symbolismInterpretation:
      "Символ объективности, честной оценки и необходимости соблюдать баланс",
    archetype: "Богиня правосудия, архетип закона и внутренней честности",
    psychology: "Потребность в честности, анализ своих поступков",
    upright: {
      personality: "Честность, объективность, логичность",
      relationships: "Необходимость баланса, решение конфликтов",
      work: "Юридические дела, оформление, заключения",
      spirituality: "Понимание причинно-следственных связей",
      examples: ["Справедливое разрешение ситуации", "Честная оценка", "Воздаяние по заслугам"]
    },
    reversed: {
      meaning: "Несправедливость, уклонение от ответственности",
      nuances: "Предвзятость, обман, сокрытие истины"
    },
    associations: ["Весы", "Закон", "Беспристрастие", "Равновесие"],
    combinations: ["С Императором — усиление правовых и формальных аспектов", "С Луной — скрытая правда"],
    readingTips: ["Не поддаваться эмоциям", "Сохранять беспристрастность"],
    selfQuestions: ["Что я оцениваю?", "Где я должен признать истину?"]
  };


